import {
  Cursive,
  CurveBanner,
  Header,
  Title,
  Wrapper,
  HeroText,
  BackgroundWrap,
  GradientWrap
} from '~/ui'
import { CursiveBasic } from '~/ui/cursive-basic'

import { CircleListItems } from '../circle-list-items'

export const HeadContent = () => (
  // <BackgroundWrap className="sliderimg bg-colorTwelve bg-consultation">
  <BackgroundWrap className="sliderimg h-full w-full lg:bg-consultation">
    <GradientWrap className="bg-colorTwelve lg:bg-transparent lg:from-colorTwelve lg:via-colorTwelve lg:to-transparent">
      <CurveBanner>
        {/* <Header className="text-colorFourteen">Consultation</Header> */}
        <div className="container mx-auto p-0 px-6">
          <h1 className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
            Consultation
          </h1>
        </div>
      </CurveBanner>
      <div className="h-[200px]" />
      <div className="relative">
        <div className="container mx-auto px-6 pt-20 mt-[-95px]">
          <div className="">
            <div className="absolute top-0 left-0 block h-full w-full bg-consultation bg-cover !bg-center lg:hidden" />
            <div className="absolute top-0 left-0 block h-full w-full bg-gradient-to-t from-colorTwelve to-transparent lg:hidden" />
            <div className="relative mt-[75px]">
              <Title className="text-colorFourteen">Personalised Nutrition</Title>
              <CursiveBasic>Tailored just for your pup</CursiveBasic>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 pt-0">
        <div className="pb-20">
          <div className="pt-5 pb-[30px] text-colorFifteen">
            <HeroText className="text-colorFourteen">
              Just like with humans, each dog's dietary needs is unique. There are tons of feeding
              plan generators and diets based on a dog's size. But so many factors play into your
              pup's optimal meal plan. We're firm believers that the best way to get your dog's
              perfect feeding plan is to hear directly from the experts. That's why we offer free
              consultations with our in-house pet nutritionists.
            </HeroText>
            <br />
            <HeroText className="text-colorFourteen">
              Tucker Tub knows dogs, with over 25 years of experience making natural dog food. Over
              the years, we've learned what works best for them, and we're here to pass that
              knowledge on. Get your pup eating and living healthy in 3 easy steps.
            </HeroText>
          </div>
          <CircleListItems />
        </div>
      </div>
    </GradientWrap>
  </BackgroundWrap>
)
